import BaseRepository from './BaseRepository';

export default class RequestQuoteBundlesRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/request-quote-bundles';
    }

    deleteRequestQuoteBundle(requestQuoteBundleId)
    {
        return this.request('DELETE', `${this.getEndpoint()}/${requestQuoteBundleId}`);
    }

    storeRequestQuoteBundle(data)
    {
        return this.request('POST', `${this.getEndpoint()}`, data);
    }
}
